import React from 'react';
import { withRouter } from 'react-router-dom';
import Select from 'react-select';
import moment from 'moment-timezone';
import DatePicker from 'react-datepicker';

const selectStyle = {
    control: styles => ({
        ...styles,
        minHeight: '0px',
        padding: '0.12em 0.6em !important',
    }),
    valueContainer: styles => ({
        ...styles,
        padding: 0,
    }),
    input: styles => ({
        ...styles,
        fontSize: '0.8em',
        lineHeight: 'normal',
    }),
    singleValue: styles => ({
        ...styles,
        fontSize: '0.8em'
    }),
    placeholder: styles => ({
        ...styles,
        fontSize: '0.8em'
    }),
    option: styles => ({
        ...styles,
        fontSize: '0.8em'
    }),
    dropdownIndicator: styles => ({
        ...styles,
        padding: '1px'
    }),
    multiValue: styles => ({
        ...styles,
        maxWidth: "300px"
    })
}

class ImpactStatementForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fiscal: true,
            selectedAgency: "",
            uploadFile: "",
            statementDate: "",
            selectedVersion: ""
        }

        this.getImpactStatementDescription = this.getImpactStatementDescription.bind(this);
        this.handleAgencyChange = this.handleAgencyChange.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
        this.submit = this.submit.bind(this);
        this.handleStatementDateChange = this.handleStatementDateChange.bind(this);
        this.handleVersionChange = this.handleVersionChange.bind(this);
    }

    handleRadioChange() {
        this.setState({
            fiscal: !this.state.fiscal
        })
    }

    handleAgencyChange(value) {
        this.setState({
            selectedAgency: value
        })
    }

    handleFileChange(e) {
        this.setState({
            uploadFile: e.target.files[0]
        })
    }

    getImpactStatementDescription() {
        if (!this.state.selectedAgency) { return "" }
        let description;
        if (!this.state.fiscal) {
            description = "Racial and Ethnic Impact Statement";
        } else if (this.state.selectedAgency.Abbreviation !== "JLARC") {
            description = "Fiscal Impact statement";
        } else {
            description = "Fiscal Impact Review";
        }

        description += " From " + this.state.selectedAgency.Abbreviation + " (" + moment().format("M/D/YYYY h:mm a") + ")";
        return description;
    }

    submit() {
        this.props.submit(this.getImpactStatementDescription(), this.state.selectedAgency.AgencyNumber, this.state.uploadFile, this.state.selectedVersion.DocumentCode);
    }

    handleStatementDateChange(value) {
        this.setState({
            statementDate: value
        })
    }

    handleVersionChange(value) {
        this.setState({
            selectedVersion: value
        })
    }

    render() {
        let description = this.getImpactStatementDescription();
        if (description) {
            description = description.substr(0, description.indexOf("("))
        }
        return (
            <div className="dlas-forms impact-statement-form">
                <div className="grid-wrapper four">
                    <div>
                        <label>Type</label>
                        <div style={{ whiteSpace: 'nowrap' }}>
                            <div style={{ display: "inline-flex", alignItems: 'center', marginRight: '1.5em' }}>
                                <label htmlFor="selected-type-button" className={`label radio-label`} style={{ whiteSpace: "no-wrap", width: 'auto' }}>Fiscal</label>
                                <input id="selected-type-button" checked={this.state.fiscal === true} onChange={() => this.handleRadioChange()} type="radio" />
                            </div>
                            <div style={{ display: "inline-flex", alignItems: 'center' }}>
                                <label htmlFor="all-sessions-button" className={`label radio-label`} style={{ whiteSpace: "no-wrap", width: 'auto' }}>Racial and Ethnic</label>
                                <input id="all-sessions-button" checked={this.state.fiscal === false} onChange={() => this.handleRadioChange()} type="radio" />
                            </div>
                        </div>
                    </div>
                    <div>
                        <label>Agency</label>
                        <Select
                            options={this.props.agencyOptions}
                            onChange={this.handleAgencyChange}
                            value={this.state.selectedAgency}
                            isSearchable
                            classNamePrefix='no-width-dropdown-input'
                            styles={selectStyle}
                        />
                    </div>
                    <div>
                        <label>Bill Text Version</label>
                        <Select
                            options={this.props.versionList}
                            onChange={this.handleVersionChange}
                            value={this.state.selectedVersion}
                            isSearchable
                            getOptionLabel={(x) => x.Description + " - " + x.DocumentCode + " - " + x.LDNumber}
                            getOptionValue={(x) => x.DocumentCode}
                            classNamePrefix='no-width-dropdown-input'
                            styles={selectStyle}
                        />
                    </div>
                    <button type="button" className="button small-button file-button" style={{ height: "28px", marginTop: "24px" }}>
                        <input style={{ marginTop: "-5px", marginLeft: "-35px" }} type="file" accept=".pdf" onChange={this.handleFileChange} />
                        {this.state.uploadFile ? this.state.uploadFile.name : "Upload Impact Statement"}
                    </button>
                </div>
                <div style={{ marginTop: "10px" }}>
                    <p style={{ position: 'absolute' }}>{"Description: " + description}</p>
                    <div className="align-right">
                        <button type="button" className="button secondary" style={{ marginRight: "15px" }} onClick={() => this.props.toggleStatementForm()}>Cancel</button>
                        <button type="button" className="button default" disabled={this.state.uploadFile === "" || this.state.selectedAgency === "" || this.state.selectedVersion === "" || this.props.isSubmitting} onClick={() => this.submit()}>Submit Impact Statement</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(ImpactStatementForm);
